<template>
  <section>
    <div id="mySidebar" :class="[style ? 'showing' : 'hiding', 'w3-sidebar']">
      <div class="sideMenu">
        <!-- <div class="w-100 text-end">
          <v-icon @click="close()" icon="mdi-logout" class="close-menu-icon"> </v-icon>
        </div> -->
        <v-list class="">
          <v-list-item
            v-for="(item, index) in items"
            :key="index"
            @click="navigateTo(item.route)"
            :class="{ active: isActive(item.route) }"
          >
            <v-list-item-title>{{ $t(item.text) }}</v-list-item-title>
          </v-list-item>
        </v-list>
        <Authriz class="w-100 text-center mt-5" />
        <div class="icon-wrapper w-100 ps-1 mt-5">
          <v-icon @click="close()" icon="mdi-logout" class="close-menu-icon"> </v-icon>
        </div>
      </div>
    </div>

    <v-icon icon="mdi-menu" class="icon-menu" @click="open()"></v-icon>
  </section>
</template>

<script>
  import Authriz from "./Authriz";

  export default {
    components: {
      Authriz,
    },
    data() {
      return {
        style: false,
        checksboxes: true,
        copunstype: true,
        copunsorder: true,
        copunsview: true,
        items: [
          { text: "Home", route: "/" },
          { text: "Real_estate", route: "/real-estate" },
          { text: "Support-Service", route: "/support-service" },
          { text: "Blog", route: "/blog" },
          { text: "About", route: "/about-us" },
          { text: "Contact", route: "/contact" },
        ],
      };
    },
    methods: {
      open() {
        this.style = !this.style;
      },

      close() {
        this.style = !this.style;
      },
      isActive(route) {
        return this.$route.path === route;
      },
      navigateTo(route) {
        this.$router.push(route);
        this.close();
      },
    },
  };
</script>
<style scoped lang="scss">
  $main-color: #0074c7;
  $second-color: #fff;
  .sideMenu {
    padding: 4rem 1rem 1rem 1rem;
  }

  .v-list-item {
    transition: background 0.2s, color 0.2s;
    border-radius: 8px;
    cursor: pointer;
    &:hover {
      background: $main-color;
      .v-list-item-title {
        color: $second-color !important;
      }
    }
    &.active {
      background: linear-gradient(90deg, $main-color 70%, $second-color 100%);
      .v-list-item-title {
        color: $second-color !important;
      }
    }
  }

  .v-list-item-title {
    color: $main-color;
    font-weight: bold;
    font-size: 1.1rem;
    transition: color 0.2s;
  }
  .icon-wrapper{
  }

  .icon-menu {
    display: none;
  }

  .hiding {
    display: none;
  }
  .w3-sidebar {
    height: 100%;
    width: 280px;
    background-color: #fff;
    position: fixed !important;
    z-index: 1111;
    overflow: auto;
    right: 0;
    top: 0;
    box-shadow: 12px 5px 40px 6px rgba(70, 87, 147, 0.08);
  
  }
  @media (max-width: 991.98px) {
    .showing {
      display: block;
    }
    .icon-menu {
      display: block;
    }
    .navitem {
      display: none !important;
    }
  }

  .close-menu-icon {
    color: $main-color;
    font-size: 2rem;
    cursor: pointer;
    transition: color 0.2s;
    &:hover {
      color: #d32f2f;
    }
  }
</style>
